import { Select, useComputedColorScheme } from '@mantine/core';
import { useActiveForm } from 'pages/claims/components';
import React from 'react';

interface ModalSelectItem {
  label: string;
  value: string;
  disabled?: boolean;
}

interface ModalSelectGroup {
  group: string;
  items: ModalSelectItem[];
}

interface GroupedModalSelectInputProps {
  label: string;
  required?: boolean;
  accessorKey: string;
  options: ModalSelectGroup[];
  disabled?: boolean;
}

export const ModalGroupedSelectInput: React.FC<
  GroupedModalSelectInputProps
> = ({ label, required = false, accessorKey, options, disabled = false }) => {
  const computedColorScheme = useComputedColorScheme('dark');
  const color = computedColorScheme === 'dark' ? 'white' : 'black';
  const { form, prefix } = useActiveForm();

  const path = prefix ? `${prefix}.${accessorKey}` : accessorKey;

  const inputProps = form.getInputProps(path);

  return (
    <React.Fragment key={accessorKey}>
      <Select
        key={path}
        radius="md"
        withAsterisk={required}
        size="md"
        label={label}
        data={options}
        c={color}
        disabled={disabled}
        {...inputProps}
      />
    </React.Fragment>
  );
};
